/**
 * Created by mac on 7/22/17.
 */

Score.prototype.updatePoints = function (collectAllStars) {
    if (!this.required) {
        this.required = this.calcRequired();
    }

    if (this.stars === undefined) {
        this.stars = 0;
    }

    const percent = collectAllStars ? 100 : Math.min(this.calcCurrentGoals() / this.calcTargetGoals() * 100, 100);
    const points = Math.ceil(percent / 100 * this.required);

    if (points > this.points) {
        this.points = points;

        this.trigger("onChange", { percent });

        const newStars = this.calcStars();

        for (let i = this.stars + 1; i <= newStars; i++) {
            this.trigger("onChange", { star: i });
        }

        this.stars = newStars;
    }
};

Score.prototype.calcStars = function () {
    for (let i = 0; i < Score.COEFS.length; i++) {
        if (this.points < Score.COEFS[i] * this.required) {
            return i;
        }
    }

    return Score.COEFS.length;
};

Score.prototype.calcTargetGoals = function () {
    const game = Game.currentGame;
    let total = 0;
    for (const type in game.goals.elements) {
        total += game.goals.elements[type].target;
    }

    return total;
};

Score.prototype.calcCurrentGoals = function () {
    const game = Game.currentGame;
    let total = 0;
    for (const type in game.goals.elements) {
        total += Math.min(game.goals.elements[type].amount, game.goals.elements[type].target);
    }

    return total;
};

Score.prototype.calcRequired = function () {
    const game = Game.currentGame;
    const targetGoals = this.calcTargetGoals();

    let required = targetGoals * 10;

    const cellsByMoves = game.beginMoves * 5;
    if (cellsByMoves > targetGoals && game.beginMoves > 0) {
        required += (cellsByMoves - targetGoals) * 3;
    }

    return required;
};

Score.COEFS = [0.5, 0.75, 1.0];